module.exports = __webpack_public_path__ + "img/stop.5f1b2ad1.svg";